import { render, staticRenderFns } from "./ProductFormPage.vue?vue&type=template&id=46292d4a&scoped=true&"
import script from "./ProductFormPage.vue?vue&type=script&lang=ts&"
export * from "./ProductFormPage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductFormPage.vue?vue&type=style&index=0&id=46292d4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46292d4a",
  null
  
)

export default component.exports